import React from 'react';
import { Icon } from './Icon.js';
export const IconCheck2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polyline", { points: "6.5 10.5 8.75 13 13.5 7", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconCheck2.js.map